import { Pipe, PipeTransform } from '@angular/core';

/**
 * TruncatePipe
 * Takes a numerical string as an argument that is truncated
 * by the provided number of "places".
 *
 * Usage: value | truncate:places
 * Example:
 *  {{ '5.000' | truncate:1 }}
 *  formats to 5.0
 */

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, places: number): string {
    return (+value).toFixed(places);
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/truncate.pipe.ts